import React, { useState, useEffect } from "react";
import Common_Banner from "../common-components/common_banner/Common_Banner"; // ✅ Import banner
import Common_Banner_2 from "../common-components/common_banner_2/Common_Banner_2";
import { PrivacyPolicys } from "../../utils/apis/privacypolicy/PrivacyPolicy";

const PrivacyPolicy = () => {
  const [banner, setBanner] = useState([]);

  const getBanner = async () => {
    try {
      const res = await PrivacyPolicys();

      if (res?.success) {
        setBanner(res?.data || []);
      }
    } catch (error) {
      console.error("Error fetching privacy policy:", error);
    }
  };

  useEffect(() => {
    getBanner();
  }, []);

  // Get latest updatedAt
  const latestUpdatedDate =
    banner?.length > 0
      ? [...banner].sort(
          (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
        )[0]?.updatedAt
      : null;

  // Format date
  const formatDate = (date) => {
    if (!date) return "";

    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <div className="terms-wrapper">
      {/* ✅ Replaced old banner with Common_Banner */}
      {/* <Common_Banner
        imgSrc="/assets/images/privacypolicy/privacy.png"
        title="Terms & Conditions"
      /> */}

      <Common_Banner_2
        imgSrc="/assets/images/home/commng-soon/agri_bg.png"
        title_text="Privacy Policy"
      />

      {/* <div className="container mt-5">

        <h1>Privacy Policy</h1>
        <p className="updated">Last Updated: {formatDate(latestUpdatedDate)}</p>

        <p>
          Seedso Agro ("Company", "we", "our", or "us") respects your privacy
          and is committed to protecting your personal information. This Privacy
          Policy explains how we collect, use, disclose, store, and protect
          information when you access or use our Website.
        </p>

        <p>
          By accessing or using this Website, you consent to the practices
          described in this Privacy Policy.
        </p>

        <h2>1. About This Website</h2>

        <p>
          This Website provides information about Seedso Agro's agricultural
          products, fertilizers, crop nutrition solutions, bio-products,
          micronutrients, farming technologies, and related services.
        </p>

        <p>
          The Website is intended to help farmers, distributors, dealers,
          retailers, and agricultural businesses learn more about our products
          and services. Any inquiries submitted through the Website will be
          handled by our team.
        </p>

        <h2>2. Information We Collect</h2>

        <h5>Information You Voluntarily Provide</h5>

        <p>We may collect personal information through:</p>

        <ul>
          <li>Contact forms</li>
          <li>Product inquiry forms</li>
          <li>Dealer or distributor registration forms</li>
          <li>Farmer inquiry forms</li>
          <li>Customer support requests</li>
          <li>Email communications</li>
        </ul>

        <p>Such information may include:</p>

        <ul>
          <li>Name</li>
          <li>Email Address</li>
          <li>Mobile Number</li>
          <li>Company or Farm Name</li>
          <li>City and State</li>
          <li>Crop Information (if provided)</li>
          <li>Any details included in your inquiry</li>
        </ul>

        <h5>Automatically Collected Information</h5>

        <p>When you visit our Website, we may automatically collect:</p>

        <ul>
          <li>IP Address</li>
          <li>Browser Type</li>
          <li>Operating System</li>
          <li>Device Information</li>
          <li>Pages Visited</li>
          <li>Date & Time of Visit</li>
          <li>Referral Source</li>
          <li>Website Usage Analytics</li>
        </ul>

        <p>
          This information helps us improve Website performance, security, and
          user experience.
        </p>

        <h2>3. How We Use Your Information</h2>

        <p>We may use your information to:</p>

        <ul>
          <li>Respond to product or farming inquiries.</li>
          <li>
            Provide information about fertilizers and agricultural products.
          </li>
          <li>Assist dealers, distributors, and business partners.</li>
          <li>Improve our Website and customer experience.</li>
          <li>Analyze Website traffic and visitor behavior.</li>
          <li>Maintain Website security.</li>
          <li>Comply with legal obligations.</li>
        </ul>

        <h2>4. Cookies and Tracking Technologies</h2>

        <p>
          Our Website may use cookies and similar technologies to improve
          functionality, analyze visitor behavior, and enhance user experience.
        </p>

        <p>
          You may disable cookies through your browser settings, although
          certain Website features may not function properly.
        </p>

        <h2>5. Third-Party Links</h2>

        <p>
          Our Website may contain links to third-party websites including
          agricultural partners, distributors, research organizations,
          government portals, or social media platforms.
        </p>

        <p>
          Once you leave our Website, you become subject to the privacy policies
          and terms of those third-party websites.
        </p>

        <p>Seedso Agro is not responsible for:</p>

        <ul>
          <li>Privacy practices of third-party websites.</li>
          <li>Content published by third parties.</li>
          <li>Information collected by external websites.</li>
          <li>Security practices of third-party platforms.</li>
        </ul>

        <h2>6. Sharing of Information</h2>

        <p>We do not sell, rent, or trade your personal information.</p>

        <p>We may share information with:</p>

        <ul>
          <li>Website Hosting Providers</li>
          <li>Technology Service Providers</li>
          <li>Analytics Providers</li>
          <li>Professional Advisors</li>
          <li>Government Authorities where legally required</li>
        </ul>

        <p>
          Such sharing is limited to what is necessary for legitimate business
          operations and legal compliance.
        </p>

        <h2>7. Data Security</h2>

        <p>
          We implement appropriate administrative, technical, and organizational
          measures to protect your personal information against unauthorized
          access, misuse, disclosure, alteration, or destruction.
        </p>

        <p>
          However, no internet transmission or electronic storage system is
          completely secure, and we cannot guarantee absolute security.
        </p>

        <h2>8. Data Retention</h2>

        <p>We retain personal information only as long as necessary to:</p>

        <ul>
          <li>Respond to inquiries.</li>
          <li>Provide customer support.</li>
          <li>Maintain business records.</li>
          <li>Comply with applicable legal requirements.</li>
        </ul>

        <p>
          Information no longer required may be securely deleted or anonymized.
        </p>

        <h2>9. Your Rights</h2>

        <p>
          Subject to applicable laws, including the Digital Personal Data
          Protection Act, 2023 (India), you may have the right to:
        </p>

        <ul>
          <li>Access your personal information.</li>
          <li>Correct inaccurate information.</li>
          <li>Request deletion of your personal data.</li>
          <li>Withdraw consent where applicable.</li>
          <li>Understand how your information is used.</li>
        </ul>

        <h2>10. Children's Privacy</h2>

        <p>
          This Website is intended for adults and business users. We do not
          knowingly collect personal information from children under the age of
          18.
        </p>

        <h2>11. Consent</h2>

        <p>
          By submitting any inquiry or registration form on this Website, you
          consent to the collection, storage, and processing of your information
          for responding to your requests and providing relevant agricultural
          products and services.
        </p>

        <h2>12. Agricultural Product Disclaimer</h2>

        <p>
          Information provided on this Website is intended for general
          informational purposes only.
        </p>

        <p>
          Product recommendations may vary depending on crop type, soil
          condition, climate, irrigation practices, and other agricultural
          factors. Farmers are encouraged to consult qualified agricultural
          experts before applying any fertilizer or crop nutrition product.
        </p>

        <p>
          Seedso Agro shall not be responsible for crop performance variations
          resulting from improper application, environmental conditions, or
          farming practices beyond our control.
        </p>

        <h2>13. Website Disclaimer</h2>

        <p>
          While we strive to keep all information accurate and up to date,
          Seedso Agro makes no warranties regarding the completeness,
          reliability, or suitability of the information provided on this
          Website.
        </p>

        <p>
          Product specifications, packaging, recommendations, and availability
          may change without prior notice.
        </p>

        <h2>14. Changes to This Privacy Policy</h2>

        <p>
          We may update this Privacy Policy from time to time. Any changes will
          be posted on this page along with the updated revision date.
        </p>

        <p>
          Continued use of the Website after any changes constitutes acceptance
          of the updated Privacy Policy.
        </p>

        <h2>15. Contact Us</h2>

        <div class="contact-box">
          <p>
            <strong>Seedso Agro</strong>
          </p>
          <p>
            <strong>Email:</strong> info@seedsoagro.com
          </p>
          <p>
            <strong>Phone:</strong> +91 XXXXXXXXXX
          </p>
          <p>
            <strong>Address:</strong> Your Registered Office Address, Pune,
            Maharashtra, India
          </p>
        </div>
      </div> */}

      <div className="container mt-5">
        <h1>Privacy Policy</h1>

        {/* Latest Updated Date */}
        <p className="updated">Last Updated: {formatDate(latestUpdatedDate)}</p>

        {/* Dynamic Terms Content */}
        {banner?.map((item, index) => (
          <div key={item?.id || index}>
            <h2>
              {index + 1}. {item?.name}
            </h2>

            <div
              dangerouslySetInnerHTML={{
                __html: item?.description || "",
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PrivacyPolicy;
